<template>
  <div>
    <v-app-bar
      color="green"
      dark>
      <h3>
        <v-icon>mdi-binoculars</v-icon>
        C. 現地における目視調査
      </h3>
    </v-app-bar>
    <stepper
      v-model="step"
      session-key-prefix="field-survey-step"
      :items="steps" />
    <field-form-step1
      v-if="step===1"
      :id="id"
      @change="goStep" />
    <field-form-step2
      v-if="step===2"
      :id="id"
      :previous-object="previousObject"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <field-form-step3
      v-if="step===3"
      :id="id"
      :statuses="statuses"
      :reasons="reasons"
      :samplings="samplings"
      :results="results"
      :sampling-results="samplingResults"
      :previous-object="previousObject"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <field-form-step4
      v-if="step===4"
      :id="id"
      @hasChange="fetchIsChanged"
      @change="goStep" />
  </div>
</template>

<script>
import FieldFormStep1 from './FormStep1'
import FieldFormStep2 from './FormStep2'
import FieldFormStep3 from './FormStep3'
import FieldFormStep4 from './FormStep4'
import Stepper from '../Stepper'
import { getStepSession } from '../../logic/session'

import LeaveConfirm from '../../mixins/LeaveConfirm'

export default {
  name: 'FieldForm',
  components: {
    Stepper,
    FieldFormStep1,
    FieldFormStep2,
    FieldFormStep3,
    FieldFormStep4,
  },
  mixins: [LeaveConfirm],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      default: () => ([
        { id: 1, title: '整合性確認表の選択' },
        { id: 2, title: '部屋情報の入力' },
        { id: 3, title: '現地における目視調査情報の入力' },
        { id: 4, title: '現地における目視調査情報の保存' },
      ]),
    },
  },
  data() {
    return {
      statuses: [],
      reasons: [],
      samplings: [],
      results: [],
      samplingResults: [],
      previousObject: {},
    }
  },
  watch: {
    id(newVal) {
      if (newVal) {
        this.fetchPreviousObject()
      }
    },
  },
  beforeUpdate() {
    if (getStepSession('field-survey', 4)) {
      this.$router.push({ name: 'index' })
    }
  },
  mounted() {
    this.fetchItem()
    if (this.id) {
      this.fetchPreviousObject()
    }
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get('/api/field-surveys/props')
      this.statuses = data.statuses
      this.reasons = data.reasons
      this.samplings = data.samplings
      this.results = data.results
      this.samplingResults = data.sampling_results
    },
    async fetchPreviousObject() {
      // 差分抽出のため、前回承認前の値(previous_object)を取得する。
      const { data } = await window.axios.get(`/api/field-surveys/${this.id}`)
      const { previous_object: object } = data
      if (!object || !object.id || !object.field_survey_created_at) {
        this.previousObject = {}
        return
      }
      this.previousObject = object
    },
    goStep(step) {
      this.$router.push({ name: `fieldSurveyEditStep${step}` })
    },
  },
}
</script>
